import type { RequestStatus } from '@transcend-io/privacy-types';
import { createEnum, filterEnum } from '@transcend-io/type-utils';

import { REQUEST_STATUSES } from './statuses';

/**
 * The statuses where a request can be canceled by an organization member
 *
 * This is true if request statuses that can transition to canceled state
 */
export const REQUEST_STATUSES_CANCELABLE = filterEnum(
  REQUEST_STATUSES,
  ({ transitions }) => transitions.includes('CANCELED'),
);

/**
 * The statuses that can be canceled key by status
 */
export const REQUEST_STATUS_CANCELABLE = createEnum(
  REQUEST_STATUSES_CANCELABLE,
);

/**
 * Check if a request can be canceled from its current state
 *
 * @param status - The status of the request to check
 * @returns True if the request can be canceled from its current state
 */
export function canCancel(status: RequestStatus): boolean {
  return status in REQUEST_STATUS_CANCELABLE;
}
